var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { RenderIf } from 'syf-component-library/ui/atoms';
import { StyledCell, StyledColumnHeader, StyledInvisibleRowGroup, StyledRow, StyledRowGroup, StyledTable, StyledTableTitle } from './subcomponents';
const TableList = ({ children, header, hideHeader, title }) => {
    const StyledHeaderGroup = hideHeader
        ? StyledInvisibleRowGroup
        : StyledRowGroup;
    return (_jsxs(_Fragment, { children: [_jsx(StyledTableTitle, { children: title }), _jsxs(StyledTable, { children: [_jsx(RenderIf, { condition: Boolean(header), children: _jsx(StyledHeaderGroup, { "aria-hidden": "true", children: _jsx(StyledRow, { children: header }) }) }), _jsx(StyledRowGroup, { children: children })] })] }));
};
TableList.Cell = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (_jsx(StyledCell, Object.assign({}, rest, { children: children })));
};
TableList.ColumnHeader = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (_jsx(StyledColumnHeader, Object.assign({}, rest, { children: children })));
};
TableList.Row = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (_jsx(StyledRow, Object.assign({}, rest, { children: children })));
};
TableList.RowGroup = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (_jsx(StyledRowGroup, Object.assign({}, rest, { children: children })));
};
export default TableList;
//# sourceMappingURL=index.js.map